import Navbar from '@/components/Navigation/Navbar'
import { createApp } from 'vue'
import './registerServiceWorker'
import './App.css'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'

// @TODO: Cache front-end assets (PWA)
// @TODO: No content to display component
createApp(App)
	.use(store)
	.use(i18n)
	.use(router)
	.component('Navbar', Navbar)
	.mount('#app')
